<script>
import axios from 'axios';
import utilsService from '@/api/utilsService';
const apiUrl = `${process.env.VUE_APP_API_URL}/api/dashboard`;
const token = utilsService.getToken();

const dashboardService = {
  async getDataMaterialGraficos(init, end, material, empresa) {
    try {
      const response = await axios.get(`${apiUrl}/materiales-rango-fecha`, { 
          params: {
          initDate: init,
          endDate: end,
          material: material,
          empresa: empresa
        },
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      return response.data;
     } catch (error) {
      if (error.response && error.response.status === 404) {
            throw new Error("No hay datos para el rango de fechas seleccionado.");
        
      } else {
        throw new Error('Error al obtener los datos, intente nuevamente.');
      }
    }
  },
  async getMaterialesLastSixMonth() {
    try {
      const response = await axios.get(`${apiUrl}/materiales-seis-meses`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      return response.data;
    } catch (error) {
      router.push('/error');
    }
  },
  
  async getMaterialesByPago() {
    try {
      const response = await axios.get(`${apiUrl}/materiales-estadopago`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      return response.data;
    } catch (error) {
      router.push('/error');
    }
  },
  
  async getDataBanner(init, end, material) {
    try {
      const response = await axios.get(`${apiUrl}/data-banner-fecha`, {
        params: {
          initDate: init,
          endDate: end,
          material: material
        },
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      return response.data;
    } catch (error) {
      router.push('/error');
    }
  },
  
  async getCamionEmpresa() {
    try {
      const response = await axios.get(`${apiUrl}/camiones-empresa`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      return response.data;
    } catch (error) {
      router.push('/error');
    }
  },

  async getChoferesMeses(init, end) {
    try {
      const response = await axios.get(`${apiUrl}/choferes-meses`, {
        params: {
          initDate: init,
          endDate: end
        },
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      return response.data;
    } catch (error) {
      router.push('/error');
    }
  }

};

export default dashboardService;
</script>